module.exports = __webpack_public_path__ + "img/img-4081d2.jpg";